import { render, staticRenderFns } from "./BalanceModal.vue?vue&type=template&id=9005ed48"
import script from "./BalanceModal.vue?vue&type=script&lang=js"
export * from "./BalanceModal.vue?vue&type=script&lang=js"
import style0 from "./BalanceModal.vue?vue&type=style&index=0&id=9005ed48&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports